import { atom } from 'recoil'

export const IsDeletingJob = atom<boolean>({
  key: 'jobDeletion/isDeleting',
  default: false,
})
